/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IPaymentContainerViewProps, IPaymentContainerItem } from './payment-container';
import { get } from 'lodash';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IPaymentTenderType, PaymentContext } from './context/payment-context';

const ItemComponent: React.FC<IPaymentContainerItem> = ({ loading, itemProps, item }) => (
    <>
        {loading}
        <Node {...itemProps}>{item}</Node>
    </>
);

const getTenderType = (selectedPaymentMethod: string) => {
    const paymentContext = React.useContext(PaymentContext);
    let paymentType: IPaymentTenderType[] = [];
    let paymentString: string = '';

    Object.entries(paymentContext.paymentModules).forEach(elementId => {
        if (paymentType.length === 0) {
            paymentType = Object.values(elementId[1]).filter(element => {
                if (element.tenderName === selectedPaymentMethod) {
                    return element;
                }
                return;
            });
            paymentString = elementId[0];
        }
    });

    paymentContext.setSelectedPaymentState(paymentType[0]);
    return paymentString;
};

export default (props: IPaymentContainerViewProps) => {
    const {
        paymentContainerProps,
        items,
        renderSelectorButtons,
        renderSelectPaymentLink,
        renderSaveButton,
        selectedPaymentMethod,
        config: { ccSurchargeFreeMessage }
    } = props;
    let paymentTenderTypeClassName: string = '';
    if (selectedPaymentMethod) {
        paymentTenderTypeClassName = getTenderType(selectedPaymentMethod.tenderName);
    }
    const { moduleState } = props;
    let isSaveButtonHidden = false;

    moduleState.childIds.map(childId => {
        const state = moduleState.getModule(childId);
        if (state.isReady) {
            isSaveButtonHidden = true;
        }
    });

    let tenderName: string | undefined;
    if (React.isValidElement(renderSelectorButtons)) {
        tenderName = get(renderSelectorButtons, 'props.children[0].props.paymentTenderType.tenderName', undefined);
    }

    const renderCcFeeMessage = () => {
        return <Msdyn365.RichTextComponent text={ccSurchargeFreeMessage} className='ms-checkout-section-container__cc-processing-fee' />;
    };

    return (
        <>
            {ccSurchargeFreeMessage && tenderName !== 'On Account' && renderCcFeeMessage()}
            {renderSelectorButtons}
            <Module {...paymentContainerProps}>
                {renderSelectPaymentLink}
                {items.map(item => {
                    if (item.id !== paymentTenderTypeClassName && item.itemProps['data-type-name']) {
                        item.itemProps.className += ` hide-payment-module`;
                    }

                    return <ItemComponent key={item.id} {...item} />;
                })}
            </Module>
            <div className={`payment-container ${isSaveButtonHidden ? 'hide-save-button' : ''}`}>{renderSaveButton}</div>
        </>
    );
};
